import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncRepayment = loadable(() => import('./Repayment'), {
  fallback: <Loader />,
});
